import React, { useEffect, useRef, useState } from "react";
import UploadAndCropImage from "./UploadAndCropImage";
import { userSigupAction } from "../../redux/slices/user/userSignUpSlice";
import { useDispatch } from "react-redux";

const UploadSignature = ({ error = () => {}, removeErrors = () => {} }) => {
  const signUpFormRef = useRef();
  const cropperRef = useRef();
  const dispatch = useDispatch();

  const [croppedImage, setCroppedImage] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);

  useEffect(() => {
    if (croppedImage?.length > 0) {
      dispatch(userSigupAction.signBase64Value(croppedImage));
    } else {
      dispatch(userSigupAction.signBase64Value(null));
    }
  }, [croppedImage]);

  useEffect(() => {
    if (selectedFile?.length > 0) {
      removeErrors();
    }
  }, [selectedFile]);

  return (
    <div className="upload-sign-wrapper">
      <UploadAndCropImage
        croppedImage={croppedImage}
        setCroppedImage={setCroppedImage}
        selectedFile={selectedFile}
        setSelectedFile={setSelectedFile}
        cropperRef={cropperRef}
        signUpFormRef={signUpFormRef}
        name={"Signature"}
        removeErrors={removeErrors}
      />
      {error}
    </div>
  );
};

export default UploadSignature;
